/// <amd-module name="Build/Common/Library/TaskCheckLogLineService" />
import { issueRequest } from "VSS/Platform/Fetch";
import { routeUrl } from "VSS/Platform/Location";


import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";

export interface ITaskCheckLogLineService extends IVssService {
    /**
     * Fetches the last lineCount lines of the check log.
     */
    getLastCheckLogLine(pageContext: IVssPageContext, planId: string, logId: number, projectId: string, lineCount: number ): Promise<string>;
}


class TaskCheckLogLineService extends VssService implements ITaskCheckLogLineService {    
    private _logLineCache: Map<string, string> = new Map<string, string>();

   
    /**
     * Fetches the last lineCount lines of the check log.
     */
    public async getLastCheckLogLine(pageContext: IVssPageContext, planId: string, logId: number, projectId: string, lineCount: number ): Promise<string> {
        if (lineCount <= 0) {
            return Promise.resolve("");
        }
    
        const startLine = lineCount - 1;
        const endLine = lineCount;
        const paramKey = this._getKey(planId, logId, projectId, startLine.toString(), endLine.toString())
        if (this._logLineCache.has(paramKey)) {
            return Promise.resolve(this._logLineCache.get(paramKey) as string);
        }
    
        const response = await issueRequest(this._getUrl(pageContext, planId, logId, projectId, startLine.toString(), endLine.toString())).then((result) => {
            return result.json();
        }, (error) => {
            return "";
        });

        const logLine = response?.value?.join("\n");
        this._logLineCache.set(paramKey, logLine); //Cache the response value        
        return logLine;
    }
    
    
    private _getUrl(pageContext: IVssPageContext, planId: string, logId:number, projectId: string, startLine: string, endLine: string): string {
        return routeUrl(pageContext, "ms.vss-build-web.check-log-line-api-route", { projectId: projectId, hubName: "checks", planId: planId, logId: logId?.toString(), startLine: startLine, endLine: endLine});
    }

    private _getKey(planId: string, logId:number, projectId: string, startLine: string, endLine: string): string {
        return `${planId}_${logId}_${projectId}_${startLine}_${endLine}`;
    }
}

Services.add("ITaskCheckLogLineService", { serviceFactory: TaskCheckLogLineService });
